import React from "react";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import HomeComponent from "app/home/HomeComponent";
import DesktopSidebarComponent from "app/sidebar/DesktopSidebarComponent";
import MenuComponent from "app/menu/MenuComponent";
import ForgotPasswordComponent from "app/auth/ForgotPasswordComponent";
import SignInComponent from "app/auth/SignInComponent";
import SignOutComponent from "app/auth/SignOutComponent";
import PrivateRoute from "app/auth/PrivateRoute";
import TenantSelectorComponent from "app/auth/TenantSelectorComponent";

const Console = () => {
  return (
    <>
      <MenuComponent />
      <DesktopSidebarComponent />
      <HomeComponent />
    </>
  );
};

export default withRouter(function App() {
  return (
    <div className="app-root">
      <Switch>
        <Route exact path="/login" component={SignInComponent} />
        <Route exact path="/logout" component={SignOutComponent} />
        <Route
          exact
          path="/forgotPassword"
          component={ForgotPasswordComponent}
        />
        <Route exact path="/">
          <PrivateRoute exact path="/" component={TenantSelectorComponent} />
        </Route>
        <Route exact path={["/t/:tenantId", "/t/:tenantId/:section"]}>
          {/* We need to nest the PrivateRoute inside a Route in order for PrivateRoute to receive
            the URL parameters :tenantId and :section */}
          <PrivateRoute path="/t/:tenantId" component={Console} />
        </Route>
        <Route path="*">
          <Redirect to={{ pathname: "/" }} />
        </Route>
      </Switch>
    </div>
  );
});
